import { GameplaySkeleton } from "@modules/shared/components/GameplaySkeleton";
import dynamic from "next/dynamic";

export default dynamic(() => import("@modules/home/view/home/Container"), {
    ssr: false,
    loading: () => <GameplaySkeleton id="HomeContainer" />,
});
